(function () {
  'use strict';

  if (window.__ANATOMY_KLAVIYO_IDENTITY_SYNC_LOADED__) return;
  window.__ANATOMY_KLAVIYO_IDENTITY_SYNC_LOADED__ = true;

  var VERSION = '2026-08-01-customer-privacy';
  var ATTRIBUTION_KEY = 'anatomy_attribution_v1';
  var SESSION_KEY = 'anatomy_attribution_session_v1';
  var VISITOR_ID_KEY = 'anatomy_visitor_id_v1';
  var IDENTITY_KEY = 'anatomy_identity_v1';
  var SYNC_KEY = 'anatomy_klaviyo_identity_sync_v1';
  var POSTHOG_IDENTIFY_SYNC_KEY = 'anatomy_posthog_identity_sync_v1';
  var FUNNEL_STATE_KEY = 'anatomy_funnel_state_v1';
  var DEBUG = /(?:[?&])klaviyo_identity_debug=1(?:&|$)/.test(window.location.search);
  var pendingIdentities = [];
  var pendingLearnqCommands = [];

  function log(message, payload) {
    if (!DEBUG || !window.console || !window.console.info) return;
    window.console.info('[ANATOMY Klaviyo identity]', message, payload || {});
  }

  function truncate(value, maxLength) {
    if (value === null || typeof value === 'undefined') return '';
    var stringValue = String(value);
    if (stringValue.length <= maxLength) return stringValue;
    return stringValue.slice(0, maxLength - 3) + '...';
  }

  function readJson(storage, key) {
    try {
      var value = storage.getItem(key);
      return value ? JSON.parse(value) : {};
    }
    catch (error) {
      return {};
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    }
    catch (error) {}
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    }
    catch (error) {
      return '';
    }
  }

  function privacyManager() {
    return window.AnatomyCustomerPrivacy || null;
  }

  function privacySnapshot() {
    var privacy = privacyManager();
    if (!privacy || typeof privacy.snapshot !== 'function') return { status: 'missing' };
    return privacy.snapshot();
  }

  function analyticsAndMarketingAllowed() {
    var privacy = privacyManager();
    return !!privacy
      && typeof privacy.identityAllowed === 'function'
      && privacy.identityAllowed() === true;
  }

  function identityPermission(options) {
    options = options || {};
    if (options.emailConsent !== true || !analyticsAndMarketingAllowed()) return false;
    if (options.advertising !== true) return true;
    var privacy = privacyManager();
    return !!privacy
      && typeof privacy.advertisingAllowed === 'function'
      && privacy.advertisingAllowed() === true;
  }

  function queueIdentity(kind, value, reason, extra, options) {
    var snapshot = privacySnapshot();
    if (snapshot.status !== 'loading' || !options || options.emailConsent !== true) return false;
    var signature = [kind, value, reason || '', options.advertising === true ? 'advertising' : 'identity'].join('|');
    var alreadyQueued = pendingIdentities.some(function (pending) {
      return pending.signature === signature;
    });
    if (alreadyQueued) return false;
    pendingIdentities.push({
      signature: signature,
      kind: kind,
      value: value,
      reason: reason || '',
      extra: extra || {},
      options: {
        emailConsent: true,
        advertising: options.advertising === true,
        force: options.force === true,
        defer: false
      }
    });
    if (pendingIdentities.length > 10) pendingIdentities.shift();
    return true;
  }

  function clearIdentitySession() {
    try {
      window.sessionStorage.removeItem(SYNC_KEY);
      window.sessionStorage.removeItem(POSTHOG_IDENTIFY_SYNC_KEY);
    }
    catch (error) {}
  }

  function pushLearnqCommand(command) {
    window._learnq = window._learnq || [];
    pendingLearnqCommands.push(command);
    window._learnq.push(command);
  }

  function removePendingLearnqCommands() {
    if (Array.isArray(window._learnq)) {
      for (var index = window._learnq.length - 1; index >= 0; index -= 1) {
        if (pendingLearnqCommands.indexOf(window._learnq[index]) !== -1) {
          window._learnq.splice(index, 1);
        }
      }
    }
    pendingLearnqCommands = [];
  }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function emailFromElement(element) {
    if (!element || !element.querySelector) return '';
    var input = element.querySelector('input[type="email"], input[name*="email" i], input[id*="email" i]');
    var value = input && input.value ? input.value.trim() : '';
    return isEmail(value) ? value : '';
  }

  function emailFromObject(input, depth) {
    if (!input || depth > 3) return '';

    if (typeof input === 'string') {
      return isEmail(input) ? input.trim() : '';
    }

    if (Array.isArray(input)) {
      for (var arrayIndex = 0; arrayIndex < input.length; arrayIndex += 1) {
        var arrayEmail = emailFromObject(input[arrayIndex], depth + 1);
        if (arrayEmail) return arrayEmail;
      }
      return '';
    }

    if (typeof input !== 'object') return '';

    var keys = Object.keys(input);
    for (var index = 0; index < keys.length; index += 1) {
      var key = keys[index];
      var value = input[key];
      if (/email/i.test(key) && isEmail(value)) return String(value).trim();
    }

    for (var nestedIndex = 0; nestedIndex < keys.length; nestedIndex += 1) {
      var nestedEmail = emailFromObject(input[keys[nestedIndex]], depth + 1);
      if (nestedEmail) return nestedEmail;
    }

    return '';
  }

  function visitorId() {
    try {
      return window.localStorage.getItem(VISITOR_ID_KEY) || '';
    }
    catch (error) {
      return '';
    }
  }

  function posthogSessionId() {
    try {
      if (window.posthog && typeof window.posthog.get_session_id === 'function') {
        return window.posthog.get_session_id() || '';
      }
    }
    catch (error) {}
    return '';
  }

  function sha256(value) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.resolve('');
    }

    var bytes = new TextEncoder().encode(String(value || '').trim().toLowerCase());
    return window.crypto.subtle.digest('SHA-256', bytes).then(function (buffer) {
      var hash = '';
      var view = new Uint8Array(buffer);
      for (var index = 0; index < view.length; index += 1) {
        hash += view[index].toString(16).padStart(2, '0');
      }
      return hash;
    }).catch(function () {
      return '';
    });
  }

  function attrValue(attribution, touch, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution[touch] && attribution[touch][key]) return attribution[touch][key];
    return '';
  }

  function contextValue(attribution, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution.context && attribution.context[key]) return attribution.context[key];
    return '';
  }

  function normalizeSource(source, clickIds) {
    source = String(source || '').toLowerCase();
    clickIds = clickIds || {};
    if (source.indexOf('facebook') !== -1 || source.indexOf('instagram') !== -1 || source === 'fb' || source === 'ig' || source === 'meta' || clickIds.fbclid) return 'meta';
    if (source.indexOf('tiktok') !== -1 || source === 'tt' || clickIds.ttclid) return 'tiktok';
    if (source.indexOf('google') !== -1 || source === 'adwords' || clickIds.gclid) return 'google';
    if (source.indexOf('pinterest') !== -1 || source === 'pin') return 'pinterest';
    if (source) return source;
    return 'direct_or_unknown';
  }

  function attributionQuality(props) {
    if (props.attribution_last_utm_source || props.attribution_last_utm_campaign || props.attribution_last_utm_content) return 'utm';
    if (props.attribution_last_fbclid || props.attribution_last_gclid || props.attribution_last_ttclid || props.attribution_last_msclkid) return 'click_id';
    if (props.attribution_last_referrer || props.attribution_session_referrer) return 'referrer';
    return 'direct_or_unknown';
  }

  function activeOfferCode() {
    try {
      var pathMatch = window.location.pathname.match(/\/discount\/([^\/\?#]+)/i);
      if (pathMatch && pathMatch[1]) return truncate(decodeURIComponent(pathMatch[1]), 80);
      var params = new URLSearchParams(window.location.search);
      return truncate(params.get('discount') || params.get('offer') || window.sessionStorage.getItem('anatomy_offer_code_v1') || '', 80);
    }
    catch (error) {
      return '';
    }
  }

  function add(props, key, value, maxLength) {
    var clean = truncate(value, maxLength || 300);
    if (clean === '') return;
    props[key] = clean;
  }

  function profileProperties(extra) {
    var attribution = readJson(window.localStorage, ATTRIBUTION_KEY);
    var session = readJson(window.sessionStorage, SESSION_KEY);
    var identity = readJson(window.localStorage, IDENTITY_KEY);
    var funnel = readJson(window.localStorage, FUNNEL_STATE_KEY);
    var id = visitorId();
    var props = {
      anatomy_klaviyo_sync_version: VERSION,
      anatomy_identity_stage: identity.stage || identity.identity_stage || 'email_identified',
      anatomy_identity_provider: identity.provider || identity.identity_provider || 'first_party_email',
      anatomy_visitor_id: id,
      posthog_distinct_id: id,
      last_seen_site_path: truncate(window.location.pathname, 240)
    };

    add(props, 'posthog_session_id', posthogSessionId(), 300);
    add(props, 'anatomy_identity_id', identity.anatomy_identity_id || identity.identity_profile_id, 120);
    add(props, 'epsilon_matched', identity.epsilon_matched === true ? 'true' : '', 20);
    add(props, 'epsilon_match_confidence', identity.epsilon_match_confidence || identity.match_confidence, 80);
    add(props, 'active_offer_code', activeOfferCode(), 80);
    add(props, 'anatomy_highest_funnel_stage', funnel.highest_stage, 20);
    add(props, 'anatomy_highest_funnel_event', funnel.highest_event, 120);
    add(props, 'anatomy_highest_funnel_at', funnel.highest_event_at, 80);
    add(props, 'anatomy_last_product_handle', funnel.last_product_handle, 180);
    add(props, 'anatomy_protocol_interest', funnel.protocol_interest, 120);
    add(props, 'anatomy_funnel_origin_path', funnel.last_page_path || window.location.pathname, 350);

    add(props, 'attribution_first_landing_path', attrValue(attribution, 'first', 'first_landing_path'), 350);
    add(props, 'attribution_first_utm_source', attrValue(attribution, 'first', 'first_utm_source'), 200);
    add(props, 'attribution_first_utm_medium', attrValue(attribution, 'first', 'first_utm_medium'), 200);
    add(props, 'attribution_first_utm_campaign', attrValue(attribution, 'first', 'first_utm_campaign'), 260);
    add(props, 'attribution_first_utm_content', attrValue(attribution, 'first', 'first_utm_content'), 260);
    add(props, 'attribution_first_utm_term', attrValue(attribution, 'first', 'first_utm_term'), 260);
    add(props, 'attribution_first_utm_id', attrValue(attribution, 'first', 'first_utm_id'), 160);
    add(props, 'attribution_first_utm_adset_id', attrValue(attribution, 'first', 'first_utm_adset_id'), 160);
    add(props, 'attribution_first_utm_ad_id', attrValue(attribution, 'first', 'first_utm_ad_id'), 160);
    add(props, 'attribution_first_timestamp', attrValue(attribution, 'first', 'first_timestamp'), 80);

    add(props, 'attribution_last_landing_path', attrValue(attribution, 'last', 'last_landing_path'), 350);
    add(props, 'attribution_last_utm_source', attrValue(attribution, 'last', 'last_utm_source'), 200);
    add(props, 'attribution_last_utm_medium', attrValue(attribution, 'last', 'last_utm_medium'), 200);
    add(props, 'attribution_last_utm_campaign', attrValue(attribution, 'last', 'last_utm_campaign'), 260);
    add(props, 'attribution_last_utm_content', attrValue(attribution, 'last', 'last_utm_content'), 260);
    add(props, 'attribution_last_utm_term', attrValue(attribution, 'last', 'last_utm_term'), 260);
    add(props, 'attribution_last_utm_id', attrValue(attribution, 'last', 'last_utm_id'), 160);
    add(props, 'attribution_last_utm_adset_id', attrValue(attribution, 'last', 'last_utm_adset_id'), 160);
    add(props, 'attribution_last_utm_ad_id', attrValue(attribution, 'last', 'last_utm_ad_id'), 160);
    add(props, 'attribution_last_timestamp', attrValue(attribution, 'last', 'last_timestamp'), 80);

    add(props, 'attribution_first_fbclid_present', attrValue(attribution, 'first', 'first_fbclid') ? 'true' : '', 20);
    add(props, 'attribution_first_gclid_present', attrValue(attribution, 'first', 'first_gclid') ? 'true' : '', 20);
    add(props, 'attribution_first_ttclid_present', attrValue(attribution, 'first', 'first_ttclid') ? 'true' : '', 20);
    add(props, 'attribution_last_fbclid_present', attrValue(attribution, 'last', 'last_fbclid') ? 'true' : '', 20);
    add(props, 'attribution_last_gclid_present', attrValue(attribution, 'last', 'last_gclid') ? 'true' : '', 20);
    add(props, 'attribution_last_ttclid_present', attrValue(attribution, 'last', 'last_ttclid') ? 'true' : '', 20);

    add(props, 'attribution_fbp', contextValue(attribution, 'attribution_fbp'), 300);
    add(props, 'attribution_fbc', contextValue(attribution, 'attribution_fbc'), 350);
    add(props, 'attribution_session_entry_path', session.attribution_session_entry_path || contextValue(attribution, 'attribution_session_entry_path'), 350);
    add(props, 'attribution_session_referrer', session.attribution_session_referrer || contextValue(attribution, 'attribution_session_referrer'), 500);

    props.normalized_first_source = normalizeSource(props.attribution_first_utm_source, {
      fbclid: props.attribution_first_fbclid_present,
      gclid: props.attribution_first_gclid_present,
      ttclid: props.attribution_first_ttclid_present
    });
    props.normalized_last_source = normalizeSource(props.attribution_last_utm_source, {
      fbclid: props.attribution_last_fbclid_present,
      gclid: props.attribution_last_gclid_present,
      ttclid: props.attribution_last_ttclid_present
    });
    props.attribution_quality = attributionQuality(props);
    props.is_paid_traffic = (
      props.attribution_last_utm_medium === 'paid_social'
      || props.attribution_last_utm_medium === 'paid_search'
      || props.attribution_last_utm_medium === 'cpc'
      || props.attribution_last_fbclid_present === 'true'
      || props.attribution_last_gclid_present === 'true'
      || props.attribution_last_ttclid_present === 'true'
    );

    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        if (/email|phone|name|address/i.test(key)) return;
        if (typeof extra[key] === 'undefined' || extra[key] === null || extra[key] === '') return;
        props[key] = typeof extra[key] === 'string' ? truncate(extra[key], 300) : extra[key];
      });
    }

    return props;
  }

  function signatureFor(props) {
    var keys = Object.keys(props).sort();
    var compact = {};
    keys.forEach(function (key) {
      compact[key] = props[key];
    });
    return JSON.stringify(compact);
  }

  function pushIdentify(email, props) {
    var payload = Object.assign({}, props);
    if (email) payload.$email = email;
    pushLearnqCommand(['identify', payload]);
  }

  function pushTrack(eventName, props) {
    pushLearnqCommand(['track', eventName, props]);
  }

  function identifyPostHog(email, props, reason, permissionOptions) {
    var tries = 0;

    function attempt() {
      if (!identityPermission(permissionOptions)) return;
      if (!window.posthog || typeof window.posthog.identify !== 'function') {
        if (tries++ < 40) window.setTimeout(attempt, 150);
        return;
      }

      sha256(email).then(function (hash) {
        if (!hash) return;
        if (!identityPermission(permissionOptions)) return;

        var knownId = 'email_sha256_' + hash;
        if (readSession(POSTHOG_IDENTIFY_SYNC_KEY) === knownId) return;

        var personProps = Object.assign({}, props, {
          anatomy_identity_stage: 'email_identified',
          anatomy_identity_provider: 'email_sha256',
          email_sha256: hash,
          identity_sync_reason: reason || 'email_identity'
        });

        // Split first-touch attribution into $set_once (the acquisition source is
        // written once and never overwritten by later visits) and everything else
        // into $set (last-touch + dynamic identity fields, refreshed each identify).
        // This is PostHog's recommended person-property pattern; previously every
        // field went to $set, so a returning visitor's first-touch was clobbered.
        var setOnce = {};
        var setProps = {};
        Object.keys(personProps).forEach(function (key) {
          if (key.indexOf('attribution_first_') === 0 || key === 'normalized_first_source') {
            setOnce[key] = personProps[key];
          }
          else {
            setProps[key] = personProps[key];
          }
        });

        try {
          if (typeof window.posthog.alias === 'function') {
            window.posthog.alias(knownId);
          }
          window.posthog.identify(knownId, setProps, setOnce);
          if (typeof window.posthog.capture === 'function') {
            window.posthog.capture('an_identity_identified', {
              identity_provider: 'email_sha256',
              identity_sync_reason: reason || 'email_identity',
              anatomy_visitor_id: props.anatomy_visitor_id || '',
              attribution_quality: props.attribution_quality || '',
              normalized_last_source: props.normalized_last_source || ''
            });
          }
          writeSession(POSTHOG_IDENTIFY_SYNC_KEY, knownId);
        }
        catch (error) {}
      });
    }

    attempt();
  }

  function identify(email, options) {
    options = options || {};
    email = String(email || '').trim();
    if (!isEmail(email)) return false;
    if (!identityPermission(options)) {
      if (options.defer !== false) {
        queueIdentity('email', email, options.reason, options.extra, options);
      }
      log('blocked by consent');
      return false;
    }

    var props = profileProperties(options.extra || {});
    var signature = signatureFor(props);
    if (!options.force && readSession(SYNC_KEY) === signature) {
      log('already synced this session', { reason: options.reason || '' });
      return false;
    }

    pushIdentify(email, props);
    pushTrack('ANATOMY Attribution Synced', Object.assign({}, props, {
      sync_reason: options.reason || 'email_identity'
    }));
    identifyPostHog(email, props, options.reason || 'email_identity', options);
    writeSession(SYNC_KEY, signature);

    window.dispatchEvent(new CustomEvent('anatomy:klaviyo-identity-synced', {
      detail: {
        reason: options.reason || 'email_identity',
        propertyKeys: Object.keys(props)
      }
    }));

    log('synced', {
      reason: options.reason || 'email_identity',
      propertyKeys: Object.keys(props)
    });

    return true;
  }

  function bindKlaviyoForms() {
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;

      var email = emailFromObject(detail, 0);
      if (!email) return;
      var formId = detail.formId || detail.formID || '';
      var formHosts = formId ? document.querySelectorAll('[data-klaviyo-form-id="' + formId + '"]') : [];
      var formHost = null;
      Array.prototype.some.call(formHosts, function (candidate) {
        if (candidate.offsetParent !== null) {
          formHost = candidate;
          return true;
        }
        return false;
      });
      if (!formHost && formHosts.length) formHost = formHosts[0];
      var capture = formHost && formHost.closest ? formHost.closest('[data-an-email-capture]') : null;

      identify(email, {
        reason: 'klaviyo_form_submit',
        emailConsent: true,
        extra: {
          klaviyo_form_id: formId,
          klaviyo_company_id: detail.companyId || detail.companyID || '',
          klaviyo_capture_context: capture ? capture.getAttribute('data-an-capture-context') || '' : (formHost ? formHost.getAttribute('data-an-capture-context') || '' : ''),
          klaviyo_capture_id: capture ? capture.getAttribute('data-an-capture-id') || '' : '',
          klaviyo_capture_trigger: capture ? capture.getAttribute('data-an-capture-trigger') || '' : '',
          klaviyo_capture_variant: capture ? capture.getAttribute('data-an-capture-variant') || '' : '',
          klaviyo_capture_origin_path: capture ? capture.getAttribute('data-an-capture-origin') || window.location.pathname : window.location.pathname
        }
      });
    });
  }

  function bindCustomIdentityEvents() {
    window.addEventListener('anatomy:identify-email', function (event) {
      var detail = event && event.detail ? event.detail : {};
      identify(detail.email, {
        reason: detail.reason || 'custom_identity_event',
        extra: detail.extra || {},
        force: !!detail.force,
        emailConsent: true
      });
    });
  }

  // Identify directly from a precomputed email hash (sha256 hex of trim+lowercase email),
  // bypassing the raw-email path. Same canonical (`email_sha256_<hash>`), consent gate, and
  // session dedup as identify(). Used by (a) logged-in customers — the theme injects the
  // hash server-side so no raw email touches the page — and (b) any third-party identity
  // resolver (e.g. Epsilon) that maps an anonymous visitor to a known hashed email.
  function identifyByEmailHash(hash, reason, extra, options) {
    options = options || {};
    hash = String(hash || '').trim().toLowerCase();
    if (!/^[0-9a-f]{64}$/.test(hash)) return false;
    if (!identityPermission(options)) {
      if (options.defer !== false) queueIdentity('hash', hash, reason, extra, options);
      log('hash-identify blocked by consent');
      return false;
    }
    if (!window.posthog || typeof window.posthog.identify !== 'function') {
      var attempt = Number(options.posthogAttempt || 0);
      if (attempt < 40) {
        window.setTimeout(function () {
          identifyByEmailHash(hash, reason, extra, Object.assign({}, options, {
            defer: false,
            posthogAttempt: attempt + 1
          }));
        }, 150);
      }
      return false;
    }
    var knownId = 'email_sha256_' + hash;
    if (readSession(POSTHOG_IDENTIFY_SYNC_KEY) === knownId) return false;

    var personProps = Object.assign({}, profileProperties(extra || {}), {
      anatomy_identity_stage: 'email_identified',
      anatomy_identity_provider: 'email_sha256',
      email_sha256: hash,
      identity_sync_reason: reason || 'known_hash_identity'
    });
    var setOnce = {};
    var setProps = {};
    Object.keys(personProps).forEach(function (key) {
      if (key.indexOf('attribution_first_') === 0 || key === 'normalized_first_source') setOnce[key] = personProps[key];
      else setProps[key] = personProps[key];
    });

    try {
      if (typeof window.posthog.alias === 'function') window.posthog.alias(knownId);
      window.posthog.identify(knownId, setProps, setOnce);
      if (typeof window.posthog.capture === 'function') {
        window.posthog.capture('an_identity_identified', {
          identity_provider: 'email_sha256',
          identity_sync_reason: reason || 'known_hash_identity'
        });
      }
      writeSession(POSTHOG_IDENTIFY_SYNC_KEY, knownId);
    }
    catch (error) {}
    return true;
  }

  // Generic resolver hook. ANY identity source can dispatch `anatomy:identify-hash` with
  // { email_sha256 } (or { email }) to identify the current visitor under the canonical.
  // This is the single integration point for a third-party identity-resolution provider
  // (Epsilon CORE ID, LiveRamp, etc.): the provider resolves anonymous → known hashed email,
  // fires this event, and the visitor's prior anonymous browsing folds into one person.
  function bindHashIdentityEvents() {
    window.addEventListener('anatomy:identify-hash', function (event) {
      var d = (event && event.detail) || {};
      var options = {
        emailConsent: d.emailConsent === true,
        advertising: true,
        force: !!d.force
      };
      if (d.email_sha256) identifyByEmailHash(d.email_sha256, d.reason || 'resolver_identity', d.extra || {}, options);
      else if (d.email) identify(d.email, {
        reason: d.reason || 'resolver_identity',
        extra: d.extra || {},
        force: !!d.force,
        emailConsent: options.emailConsent,
        advertising: true
      });
    });
  }

  // Logged-in customers: the theme injects window.anatomyKnownIdentity (the server-side
  // email_sha256 hash) ONLY when a customer is logged in, so we identify their browsing from
  // the first page — no orphaned anonymous sessions, and no raw email ever on the page.
  function identifyLoggedInCustomer() {
    var known = window.anatomyKnownIdentity;
    var hash = known && (known.email_sha256 || (typeof known === 'string' ? known : ''));
    var hasEmailConsent = known && typeof known === 'object' && known.emailConsent === true;
    if (!hash || !hasEmailConsent) return;
    // PostHog (anatomy-posthog.js) may bootstrap after this deferred script; poll briefly
    // so a logged-in customer is identified as soon as the SDK stub is ready.
    var tries = 0;
    (function attempt() {
      try {
        if (window.posthog && typeof window.posthog.identify === 'function') {
          identifyByEmailHash(hash, 'logged_in_customer', {}, { emailConsent: true });
          return;
        }
      }
      catch (error) { return; }
      if (tries++ < 40) setTimeout(attempt, 150);
    })();
  }

  function handlePrivacy(snapshot) {
    if (!snapshot || snapshot.status === 'loading') return;

    var queued = pendingIdentities.slice();
    pendingIdentities = [];

    if (snapshot.status !== 'ready' || !analyticsAndMarketingAllowed()) {
      removePendingLearnqCommands();
      clearIdentitySession();
      return;
    }

    // Commands assembled while advertising was permitted may contain click IDs
    // or browser ad identifiers. If that purpose is withdrawn before the vendor
    // drains its queue, remove our exact command objects and require a future
    // explicit identity action to build a newly sanitized payload.
    if (!identityPermission({ emailConsent: true, advertising: true })) {
      removePendingLearnqCommands();
    }

    queued.forEach(function (pending) {
      if (pending.kind === 'hash') {
        identifyByEmailHash(pending.value, pending.reason, pending.extra, pending.options);
        return;
      }
      identify(pending.value, {
        reason: pending.reason,
        extra: pending.extra,
        force: pending.options.force,
        emailConsent: true,
        advertising: pending.options.advertising,
        defer: false
      });
    });
  }

  window.anatomyKlaviyoIdentitySync = {
    identify: identify,
    identifyByEmailHash: identifyByEmailHash,
    getProfileProperties: function (extra) {
      if (!analyticsAndMarketingAllowed()) return {};
      return profileProperties(extra || {});
    },
    isAllowed: function () {
      return identityPermission({ emailConsent: true });
    }
  };

  // bindEmailForms() intentionally NOT called: it listened to EVERY form submit and pushed
  // a Klaviyo identify (no consent), creating "Never Subscribed" profiles from non-Klaviyo
  // forms. Identity now syncs ONLY on native Klaviyo form submits + explicit identity events.
  bindKlaviyoForms();
  bindCustomIdentityEvents();
  bindHashIdentityEvents();
  var privacy = privacyManager();
  if (privacy && typeof privacy.subscribe === 'function') privacy.subscribe(handlePrivacy);
  identifyLoggedInCustomer();
})();
